import { axios } from "../utils/request";

// 1.4.1.1 获取我的账户余额以及银行卡信息
export function getUserMoneyVo(data) {
  return axios({
    url: '/h5UserMoney/getUserMoneyVo',
    method: 'post',
    data
  })
}


// 1.4.1.5 获取微信支持转账银行列表
export function getWxBankList(data) {
  return axios({
    url: '/h5UserMoney/getWxBankList',
    method: 'post',
    data
  })
}

// 1.4.1.6 分页获取提款记录列表
export function getDrawMoneyVoListByPage(data) {
  return axios({
    url: '/h5UserMoney/getDrawMoneyVoListByPage',
    method: 'post',
    data
  })
}

// 1.4.1.2 获取提现手续费参数
export function getUserMoneyCashOutServiceCharge(data) {
  return axios({
    url: '/h5UserMoney/getUserMoneyCashOutServiceCharge',
    method: 'post',
    data
  })
}

// 1.4.1.3 新增提现申请 (需提交银行卡信息)
export function addDrawMoney(data) {
  return axios({
    url: '/h5UserMoney/addDrawMoney',
    method: 'post',
    data
  })
}


// 1.4.1.4 新增提现申请（根据上一次提现申请的银行卡记录申请）
export function addDrawMoneyByLastDrawInfo(data) {
  return axios({
    url: '/h5UserMoney/addDrawMoneyByLastDrawInfo',
    method: 'post',
    data
  })
}

// 1.4.1.7 发送提现申请验证码
export function sendDrawMoneyVerificationCode(data) {
  return axios({
    url: '/h5UserMoney/sendDrawMoneyVerificationCode',
    method: 'post',
    data
  })
}
